export const updateItem = (data) => {
    return {
        type: 'DRIVER_UPDATE_ITEM',
        payload: {
            data,
        },
    };
};
export const deleteItem = (id) => {
    return {
        type: 'DRIVER_DELETE_ITEM',
        payload: {
            id,
        },
    };
};
export const setSearchValue = (value) => {
    return {
        type: 'DRIVER_SET_SEARCH_VALUE',
        payload: {
            value,
        },
    };
};
export const setSelectedItem = (data) => {
    return {
        type: 'DRIVER_SET_SELECTED_ITEM',
        payload: {
            data,
        },
    };
};
export const setItems = (items) => {
    return {
        type: 'DRIVER_SET_ITEMS',
        payload: {
            items,
        },
    };
};
export const addItem = (data) => {
    return {
        type: 'DRIVER_ADD_ITEM',
        payload: {
            data,
        },
    };
};
